export default {
  images: [],
  loading: false
}